Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updatePropsJestWrapper = exports.default = void 0;
var _Colors = require("./Colors");
var _jsReanimated = require("./js-reanimated");
var _PlatformChecker = require("./PlatformChecker");
var _threads = require("./threads");
var updateProps;
var _worklet_3486699700956_init_data = {
    code: "function anonymous(_,updates,maybeViewRef,isAnimatedProps){const{_updatePropsJS}=this.__closure;if(maybeViewRef){maybeViewRef.items.forEach(function(item,_){_updatePropsJS(updates,item,isAnimatedProps);});}}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/UpdateProps.ts",
    sourceMap: '{"version":3,"names":["anonymous","_","updates","maybeViewRef","isAnimatedProps","_updatePropsJS","__closure","items","forEach","item"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/UpdateProps.ts"],"mappings":"AAkBgB,QAAC,CAAAA,SAAGA,CAAAC,CAAA,CAAOC,OAAE,CAAAC,YAAc,CAAAC,eAAoB,QAAAC,cAAA,OAAAC,SAAA,CAE3D,GAAIH,YAAY,CAAE,CAChBA,YAAY,CAACI,KAAK,CAACC,OAAO,CAAC,SAACC,IAAI,CAAER,CAAC,CAAK,CACtCI,cAAc,CAACH,OAAO,CAAEO,IAAI,CAAEL,eAAe,CAAC,CAChD,CAAC,CAAC,CACJ,CACF"}',
    version: "3.5.4"
};
var _worklet_9978777116601_init_data = {
    code: "function anonymous(viewDescriptors,updates){const{processColorsInProps}=this.__closure;processColorsInProps(updates);global.UpdatePropsManager.update(viewDescriptors,updates);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/UpdateProps.ts",
    sourceMap: '{"version":3,"names":["anonymous","viewDescriptors","updates","processColorsInProps","__closure","global","UpdatePropsManager","update"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/UpdateProps.ts"],"mappings":"AA2BgB,QAAC,CAAAA,UAAAC,eAAiB,CAAOC,OAAK,QAAAC,oBAAA,OAAAC,SAAA,CAE1CD,oBAAoB,CAACD,OAAO,CAAC,CAE7BG,MAAM,CAACC,kBAAkB,CAAEC,MAAM,CAACN,eAAe,CAAEC,OAAO,CAAC,CAC7D"}',
    version: "3.5.4"
};
if ((0, _PlatformChecker.shouldBeUseWeb)()) {
    updateProps = function() {
        var _e = [
            new global.Error(),
            -2,
            -27
        ];
        var anonymous = function anonymous(_, updates, maybeViewRef, isAnimatedProps) {
            if (maybeViewRef) {
                maybeViewRef.items.forEach(function(item, _) {
                    (0, _jsReanimated._updatePropsJS)(updates, item, isAnimatedProps);
                });
            }
        };
        anonymous.__closure = {
            _updatePropsJS: _jsReanimated._updatePropsJS
        };
        anonymous.__initData = _worklet_3486699700956_init_data;
        anonymous.__workletHash = 3486699700956;
        anonymous.__stackDetails = _e;
        return anonymous;
    }();
} else {
    updateProps = function() {
        var _e = [
            new global.Error(),
            -2,
            -27
        ];
        var anonymous = function anonymous(viewDescriptors, updates) {
            (0, _Colors.processColorsInProps)(updates);
            global.UpdatePropsManager.update(viewDescriptors, updates);
        };
        anonymous.__closure = {
            processColorsInProps: _Colors.processColorsInProps
        };
        anonymous.__initData = _worklet_9978777116601_init_data;
        anonymous.__workletHash = 9978777116601;
        anonymous.__stackDetails = _e;
        return anonymous;
    }();
}
var updatePropsJestWrapper = exports.updatePropsJestWrapper = function updatePropsJestWrapper(viewDescriptors, updates, maybeViewRef, animatedStyle, adapters) {
    adapters.forEach(function(adapter) {
        adapter(updates);
    });
    animatedStyle.current.value = Object.assign({}, animatedStyle.current.value, updates);
    updateProps(viewDescriptors, updates, maybeViewRef);
};
var _default = exports.default = updateProps;
var _worklet_11200805694554_init_data = {
    code: "function anonymous(){const operations=[];return{update:function(viewDescriptors,updates){var _this=this;viewDescriptors.value.forEach(function(viewDescriptor){operations.push({shadowNodeWrapper:viewDescriptor.shadowNodeWrapper,updates:updates});if(operations.length===1){queueMicrotask(_this.flush);}});},flush:function(){_updatePropsFabric(operations);operations.length=0;}};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/UpdateProps.ts",
    sourceMap: '{"version":3,"names":["anonymous","operations","update","viewDescriptors","updates","_this","value","forEach","viewDescriptor","push","shadowNodeWrapper","length","queueMicrotask","flush","_updatePropsFabric"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/UpdateProps.ts"],"mappings":"AAwDI,SAAAA,SAAMA,CAAA,EAGJ,KAAM,CAAAC,UAGH,CAAG,EAAE,CACR,MAAO,CACLC,MAAM,SAAAA,CACJC,eAA0C,CAC1CC,OAAwC,CACxC,KAAAC,KAAA,MACAF,eAAe,CAACG,KAAK,CAACC,OAAO,CAAE,SAAAC,cAAc,CAAK,CAChDP,UAAU,CAACQ,IAAI,CAAC,CACdC,iBAAiB,CAAEF,cAAc,CAACE,iBAAiB,CACnDN,OAAA,CAAAA,OACF,CAAC,CAAC,CACF,GAAIH,UAAU,CAACU,MAAM,GAAK,CAAC,CAAE,CAC3BC,cAAc,CAACP,KAAI,CAACQ,KAAK,CAAC,CAC5B,CACF,CAAC,CAAC,CACJ,CAAC,CACDA,KAAK,SAAAA,CAAA,CAAG,CAENC,kBAAkB,CAAEb,UAAU,CAAC,CAC/BA,UAAU,CAACU,MAAM,CAAG,CAAC,CACvB,CACF,CAAC,CACH"}',
    version: "3.5.4"
};
var _worklet_15634657190527_init_data = {
    code: "function anonymous(){const operations=[];return{update:function(viewDescriptors,updates){var _this=this;viewDescriptors.value.forEach(function(viewDescriptor){operations.push({tag:viewDescriptor.tag,name:viewDescriptor.name||'RCTView',updates:updates});if(operations.length===1){queueMicrotask(_this.flush);}});},flush:function(){_updatePropsPaper(operations);operations.length=0;}};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/UpdateProps.ts",
    sourceMap: '{"version":3,"names":["anonymous","operations","update","viewDescriptors","updates","_this","value","forEach","viewDescriptor","push","tag","name","length","queueMicrotask","flush","_updatePropsPaper"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/UpdateProps.ts"],"mappings":"AAqFI,SAAAA,SAAMA,CAAA,EAGJ,KAAM,CAAAC,UAIH,CAAG,EAAE,CACR,MAAO,CACLC,MAAM,SAAAA,CACJC,eAA0C,CAC1CC,OAAwC,CACxC,KAAAC,KAAA,MACAF,eAAe,CAACG,KAAK,CAACC,OAAO,CAAE,SAAAC,cAAc,CAAK,CAChDP,UAAU,CAACQ,IAAI,CAAC,CACdC,GAAG,CAAEF,cAAc,CAACE,GAAG,CACvBC,IAAI,CAAEH,cAAc,CAACG,IAAI,EAAI,SAAS,CACtCP,OAAA,CAAAA,OACF,CAAC,CAAC,CACF,GAAIH,UAAU,CAACW,MAAM,GAAK,CAAC,CAAE,CAC3BC,cAAc,CAACR,KAAI,CAACS,KAAK,CAAC,CAC5B,CACF,CAAC,CAAC,CACJ,CAAC,CACDA,KAAK,SAAAA,CAAA,CAAG,CAENC,iBAAiB,CAAEd,UAAU,CAAC,CAC9BA,UAAU,CAACW,MAAM,CAAG,CAAC,CACvB,CACF,CAAC,CACH"}',
    version: "3.5.4"
};
var createUpdatePropsManager = global._IS_FABRIC ? function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var anonymous = function anonymous() {
        var operations = [];
        return {
            update: function update(viewDescriptors, updates) {
                var _this = this;
                viewDescriptors.value.forEach(function(viewDescriptor) {
                    operations.push({
                        shadowNodeWrapper: viewDescriptor.shadowNodeWrapper,
                        updates: updates
                    });
                    if (operations.length === 1) {
                        queueMicrotask(_this.flush);
                    }
                });
            },
            flush: function flush() {
                _updatePropsFabric(operations);
                operations.length = 0;
            }
        };
    };
    anonymous.__closure = {};
    anonymous.__initData = _worklet_11200805694554_init_data;
    anonymous.__workletHash = 11200805694554;
    anonymous.__stackDetails = _e;
    return anonymous;
}() : function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var anonymous = function anonymous() {
        var operations = [];
        return {
            update: function update(viewDescriptors, updates) {
                var _this2 = this;
                viewDescriptors.value.forEach(function(viewDescriptor) {
                    operations.push({
                        tag: viewDescriptor.tag,
                        name: viewDescriptor.name || "RCTView",
                        updates: updates
                    });
                    if (operations.length === 1) {
                        queueMicrotask(_this2.flush);
                    }
                });
            },
            flush: function flush() {
                _updatePropsPaper(operations);
                operations.length = 0;
            }
        };
    };
    anonymous.__closure = {};
    anonymous.__initData = _worklet_15634657190527_init_data;
    anonymous.__workletHash = 15634657190527;
    anonymous.__stackDetails = _e;
    return anonymous;
}();
var _worklet_15750145987203_init_data = {
    code: "function anonymous(){const{createUpdatePropsManager}=this.__closure;global.UpdatePropsManager=createUpdatePropsManager();}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/UpdateProps.ts",
    sourceMap: '{"version":3,"names":["anonymous","createUpdatePropsManager","__closure","global","UpdatePropsManager"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/UpdateProps.ts"],"mappings":"AAqHmB,SAAAA,SAAMA,CAAA,QAAAC,wBAAA,OAAAC,SAAA,CAEvBC,MAAM,CAACC,kBAAkB,CAAGH,wBAAwB,CAAC,CAAC,CACxD"}',
    version: "3.5.4"
};
(0, _threads.runOnUIImmediately)(function() {
    var _e = [
        new global.Error(),
        -2,
        -27
    ];
    var anonymous = function anonymous() {
        global.UpdatePropsManager = createUpdatePropsManager();
    };
    anonymous.__closure = {
        createUpdatePropsManager: createUpdatePropsManager
    };
    anonymous.__initData = _worklet_15750145987203_init_data;
    anonymous.__workletHash = 15750145987203;
    anonymous.__stackDetails = _e;
    return anonymous;
}())();
